import { IBrokerProps, TBroker } from 'app/Pages/common';
import { TError } from 'models';
import React from 'react';
import { renderErrors } from 'app/Components/common/Error';
import Agents from './Agents';
import Structure from './Structure';
import { Loader } from 'styles/common';
import InsurersList from 'app/Components/common/InsurersList';
import { AxiosError } from 'axios';
import GeneralSettings from './GeneralSettings';
import Documents from 'app/Pages/common/Documents';
import { SortingSettings } from './SortingSettings';
import CepikSettings from './CepikSettings';
import { GDPR_COMMON_DOC_TYPE, IDD_COMMON_DOC_TYPE } from 'config/consts';

interface IProfileBody {
  brokerId: string,
  activeTab: string,
  profile: TBroker | null,
  dataStatus: string,
  errors: TError[],
  onSubmitPaymentMethods: (paymentMethods: Record<string, string[]>, onError: (errors: AxiosError) => void, onSuccess: () => void) => void,
  onSubmitProps: (props: IBrokerProps, onError: (errors: AxiosError) => void, onSuccess: () => void) => void,
}

export const ProfileBody = ({
  brokerId,
  activeTab,
  profile,
  dataStatus,
  errors,
  onSubmitPaymentMethods,
  onSubmitProps
}: IProfileBody) => {

  switch (dataStatus) {
    case 'error':
      return (
        <>
          {renderErrors(errors)}
        </>
      );
    case 'success':
      if (profile) {
        switch (activeTab) {
          case 'agents':
            return <Agents brokerId={brokerId} />;
          case 'structure':
            return <Structure profile={profile} />;
          case 'paymentMethods':
            return <InsurersList
              isEditable={false}
              onSubmitPaymentMethods={onSubmitPaymentMethods}
              paymentMethodsToProcess={profile?.props?.payment_methods}
            />;
          case 'generalSettings':
            return <GeneralSettings
              onSubmit={onSubmitProps}
              props={profile?.props}
            />;
          case 'documents':
            return <Documents refId={brokerId} docType={IDD_COMMON_DOC_TYPE} isBroker />;
          case 'sortingSettings':
            return <SortingSettings
              onSubmit={onSubmitProps}
              props={profile?.props}
            />;
          case 'cepik':
            return <CepikSettings
              onSubmit={onSubmitProps}
              props={profile?.props}
            />;
          case 'gdpr_documents':
            return <Documents refId={profile.id as string} docType={GDPR_COMMON_DOC_TYPE} isBroker />;
          default:
            return (<div>{activeTab}</div>);
        }
      }
      break;
    case 'loading':
    default:
      return <Loader />;
  }

  return <div />;
};

